import videojs from "video.js";
const button = videojs.getComponent("Button");


export const ForwardButton = ({ handleClick }) => {
//   const button = videojs.getComponent("Button");
  const control = videojs.extend(button, {
    constructor: function () {
      button.apply(this, arguments);
      this.controlText("forward owo");
      this.addClass("vjs-forward-15");
      this.el().innerHTML = "<div class='vjs-cust-btn vjs-cust-btn--ff'></div>";
    },
    handleClick: handleClick
  });
  return control;
};

export const RewindButton = ({ handleClick }) => {
    
    const control = videojs.extend(button, {
      constructor: function () {
        button.apply(this, arguments);
        this.controlText("rewind owo");
        this.addClass("vjs-rewind-15");
        this.el().innerHTML = "<div class='vjs-cust-btn vjs-cust-btn--rw'></div>";
      },
      handleClick: handleClick
    });
    return control;
  };